import axios from '../axios';

export default {
  get(id) {
    return axios.get(`/investment_entities/${id}.json`);
  },
  list() {
    return axios.get('/investment_entities.json');
  },
  choose(opportunityId, entityId) {
    return axios.post(`/opportunities/${opportunityId}/investment_entities/${entityId}/choose`);
  },
  create(opportunityId, investmentEntity) {
    return axios.post('/investment_entities.json', {
      investment_entity: investmentEntity,
      opportunity_id: opportunityId,
    });
  },
  update({ id, ...attributes }) {
    return axios.put(`/investment_entities/${id}.json`, attributes);
  },
};
